export type Suggestion = {
  id: string
  reviewed: boolean
  data: {
    [key: string]: string | number | boolean | string[] | number[] | boolean[]
  }
}

export type ValidationResult =
  | {
      valid: true
      errors?: undefined
    }
  | {
      valid: false
      errors: Record<string, string>
    }

export enum SupportedComponents {
  TextArea = 'BreakoutTextArea',
  Select = 'BreakoutSelect',
  MultiSelect = 'BreakoutMultiSelect',
  MultiTextInput = 'BreakoutMultipleTextInput',
  SegmentBuilder = 'SegmentBuilder',
  ExperiencePreview = 'ExperiencePreview',
}

export enum SupportedLayoutComponents {
  InlineGroup = 'InlineGroup',
}
